import { render, staticRenderFns } from "./officialPostManagement.vue?vue&type=template&id=60e6a6d4"
import script from "./officialPostManagement.vue?vue&type=script&lang=js"
export * from "./officialPostManagement.vue?vue&type=script&lang=js"
import style0 from "./officialPostManagement.vue?vue&type=style&index=0&id=60e6a6d4&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports